import { useEffect, useMemo } from "react";
import { useImageFilesQueries } from "shared/queries/useImageFileQueries";
import { CardBlockImage } from "../types";

type UploadSingleImageProps = {
  key: string;
  moduleId: string | null;
  setCardBlockImage: (image: CardBlockImage | null) => void;
  backgroundImagePath?: string | null;
  enabled: boolean;
};

type UploadSingleImageOutput = { loadingQuery: boolean };

export const useUploadSingleImage = ({
  key,
  moduleId,
  setCardBlockImage,
  backgroundImagePath,
  enabled,
}: UploadSingleImageProps): UploadSingleImageOutput => {
  const query = useMemo(() => {
    return {
      queryKey: [`${key}-image`, moduleId ?? ""],
      path: backgroundImagePath,
    };
  }, [key, moduleId, backgroundImagePath]);

  const [queryResult] = useImageFilesQueries({
    queries: [query],
    enabled,
  });

  const image = queryResult?.data ?? null;
  const loadingQuery = queryResult?.isFetching ?? false;

  useEffect(() => {
    if (enabled && image && !loadingQuery) {
      setCardBlockImage(image);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, image, loadingQuery]);

  return { loadingQuery };
};
